<template>
  <div id="rows-search" class="grid-container">
    <!-- <div class="callout">
      We're experiencing technical issues with the marriage license search tool. Our team is currently working to restore the service. We apologize for any inconvenience.
    </div> -->
    <div class="searchForm" v-if="!failure && showForm">
      <div class="ptl pbm">
        Fields marked with * are required
      </div>
      <div class="grid-x pbm">
        <div class="cell small-12 prl pbl">
          <label for="applicant1first">Applicant 1: First name</label>
          <input
            id="applicant1first"
            placeholder="First name"
            v-model="applicantFirst1"
            type="text"
          />
        </div>
        <div class="cell small-12 prl pbl ">
          <label for="applicant1last">Applicant 1: Last name*</label>
          <input id="applicant1last" placeholder="Last name" v-model="applicantLast1" type="text" />
        </div>
      </div>
      <div class="grid-x pbm">
        <div class="cell small-12 prl pbl ">
          <label for="applicant2first">Applicant 2: First name</label>
          <input
            id="applicant2first"
            placeholder="First name"
            v-model="applicantFirst2"
            type="text"
          />
        </div>

        <div class="cell small-12 prl pbl ">
          <label for="applicant2last">Applicant 2: Last name</label>
          <input id="applicant2last" placeholder="Last name" v-model="applicantLast2" type="text" />
        </div>
      </div>

      <div class="cell">
        <label>Search between:</label>
      </div>
      <div class="grid-x pbl">
        <div class="cell small-5 ">
        <datepicker v-model="dateFirst" :typeable="true" :disabled-dates="{to: new Date(2007, 7, 16), from: new Date() }" name="dateFirst" placeholder="Start date" format="MMM dd, yyyy" />

        </div>
        <div class="cell to-cell small-1">
        to
        </div>
        <div class="cell small-5 ">
        <datepicker v-model="dateLast" :typeable="true" :disabled-dates="{to: new Date(2007, 7, 16), from: new Date() }" name="dateLast" placeholder="End date" format="MMM dd, yyyy" />

        </div>
        
      </div>
      <div class="grid-x ptl">
        <div class="cell small-3">
        <button :disabled="disableSubmit" class="button" @click="incrementResults(1)">search</button>
        </div>
        <div class="cell small-4">
          <div v-if="showClearButton" class="button clear-btn" @click="clearInputs()">Clear</div>
        </div>
      </div>
    </div>
    <div class="results-table" v-if="licenses.length && !showForm">
      <div class="grid-x align-justify">
        <div class="all-results cell small-12 auto">
      <h2 class="mbn">
        Showing {{ totalCount }} result<span v-if="totalCount > 1">s</span>
      </h2>
      <p>Applicant names: {{ applicantFirst1 }} {{ applicantLast1 }}<span v-if="applicantFirst2 || applicantLast2">, {{ applicantFirst2 }} {{ applicantLast2 }}</span></p> 
      <p v-if="dateFirst || dateLast">Date range: {{ dateFirst | fixDate }} - {{ dateLast | fixDate }}</p> 
      </div>
      <div class="cell small-5 show-for-medium">
      <div class="button float-right mtxl"  @click="revealForm">Search Again</div>
      </div>
      </div>
      <table v-if="!loading">
        <thead>
          <tr>
            <th class="show-for-medium">
              Applicant 1 name
            </th>
            <th class="show-for-medium">
              Applicant 2 name
            </th>
            <th class="show-for-medium">Date of license</th>
            <th class="show-for-medium">License number</th>
            <th class="show-for-small-only">Applicant 1</th>
            <th class="show-for-small-only">Applicant 2</th>
            <th class="show-for-small-only">License details</th>
          </tr>
        </thead>
       
        <tbody>
          <tr v-for="license in licenses" :key="license.mlNumber + license.dateLicenseIssued">
            <td>{{ license.applicantFirst1 }} {{license.applicantLast1 }}</td>
            <td>{{ license.applicantFirst2 }} {{license.applicantLast2 }}</td>
            <td class="show-for-medium">{{ license.dateLicenseIssued | fixDate}}</td>
            <td><span class="show-for-small-only">{{ license.dateLicenseIssued | fixDate}}<br></span>{{ license.mlNumber }}   
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="loading" class="loading-icon">
        <i class="fas fa-spinner fa-spin fa-3x loadingdir" />
      </div>
      
      <div class="pag-buttons-wrap grid-x align-right">
        <div class="cell shrink small-2 bg-blue" v-if="pageNumber > 1" @click="decrementResults()"> Previous </div>
        <div class="cell shrink small-1 bg-blue" v-if="previousPage > 0 && pageNumber > 2" @click="decrementResults(1)"> 1 </div>
        <div class="cell shrink small-1 bg-blue" v-if="firstAndLast && previousPage > 0 && pageNumber > 3"> ... </div>
        <div class="cell shrink small-1 bg-blue" v-if="!firstAndLast && pageNumber == 5" @click="decrementResults(pageNumber - 3)"> {{ pageNumber - 3 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="!firstAndLast && previousPage > 0 && pageNumber > 3" @click="decrementResults(pageNumber - 2)"> {{ pageNumber - 2 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="previousPage > 0" @click="decrementResults()"> {{ pageNumber - 1 }} </div>
        <div class="cell shrink small-1 bg-white" v-if="pageNumber > 0 && totalPages > 1">{{ pageNumber }}</div>
        <div class="cell shrink small-1 bg-blue" v-if="nextPage > 0" @click="incrementResults()"> {{ pageNumber + 1 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="!firstAndLast && (pageNumber < (totalPages - 1))"> {{ pageNumber + 2 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="!firstAndLast && (pageNumber == 1) && totalPages > 3" @click="incrementResults(pageNumber + 3)"> {{ pageNumber + 3 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="!firstAndLast && (pageNumber == 2) && totalPages == 5" @click="incrementResults(pageNumber + 3)"> {{ pageNumber + 3 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="!firstAndLast && (pageNumber == 1) && totalPages == 5" @click="incrementResults(pageNumber + 4)"> {{ pageNumber + 4 }} </div>
        <div class="cell shrink small-1 bg-blue" v-if="firstAndLast && (pageNumber < (totalPages - 2))"> ... </div>
        <div class="cell shrink small-1 bg-blue" v-if="firstAndLast && pageNumber < (totalPages - 1)" @click="incrementResults(totalPages)"> {{ totalPages }} </div>
        <div class="cell shrink small-2 bg-blue" v-if="nextPage > 0" @click="incrementResults()"> Next </div>
      </div>
      <div class="button hide-for-large mtl"  @click="revealForm">search again</div>
      <div class="grid-x row callout-box">
        <div class="cell icon-container">
        <i class="fa fa-arrow-circle-right fa-3x" />
        </div>
        <div class="cell auto callout-text">
          To order a copy of a marriage record or get help finding one, <a href="https://www.phila.gov/services/birth-marriage-life-events/marriage-and-divorce/find-and-request-a-marriage-record/"> submit a research request with the Register of Wills.</a>
        </div>
      </div>
    </div>
    <div v-if="failure">
    <div class="failure-message" >
      <h3>No results found.</h3>
      <p v-if="applicantFirst2 || applicantLast2 || applicantFirst1 || applicantLast1">Applicant names: {{ applicantFirst1 }} {{ applicantLast1 }}<span v-if="applicantFirst2 || applicantLast2">, {{ applicantFirst2 }} {{ applicantLast2 }}</span></p> 
      <p v-if="dateFirst || dateLast">Date range: {{ dateFirst | fixDate }} - {{ dateLast | fixDate }}</p> 
      <p>You can try:
        <ul>
          <li>Adjusting the spelling on the applicants’ names.
          </li>
          <li>Entering only part of an applicant’s last name. (For example, “Smi” will return results for Smith, Smithson, etc.)
          </li>
          <li>Leaving out the date range for the marriage license. Licenses from before 1995 are not included in this database.
          </li>
        </ul>
      </p>
      <div class="button"  @click="revealForm">search again</div>
      </div>
      <div class="grid-x callout-box">
        <div class="cell icon-container">
        <i class="fa fa-question-circle fa-3x" />
        </div>
        <div class="cell auto callout-text">
          If you continue to have trouble finding the record you need, you can <a href="https://www.phila.gov/services/birth-marriage-life-events/marriage-and-divorce/find-and-request-a-marriage-record/">submit a research request with the Register of Wills. </a>
        </div>
      </div>
    
    </div>
  </div>
</template>

<script>
const rowsSlug = "https://api.phila.gov/row-api/api/marriage-records/search?";
// for testing 
// const rowsSlug = "https://api-test.phila.gov/row-api-test/api/marriage-records/search?";

import axios from "axios";
import Datepicker from "vuejs-datepicker";
import moment from 'moment';


export default {
  name: "SearchForm",
  components: {
    Datepicker,
  },
  props: {},
  mounted() {},
  filters: {
    fixDate: function(value) {
      let dateFloor = new Date(2007, 7, 16); //months are 0 indexed for some reason
      let mlDate = new Date(value)
      if (mlDate < dateFloor) {
        return "";
      }
      // let month = mlDate.getUTCMonth() + 1; //months from 1-12
      // let day = mlDate.getUTCDate();
      // let year = mlDate.getUTCFullYear();
      let newdate = moment(mlDate).utcOffset(0).format("MMM D, YYYY");
      return newdate
    },
  },
  computed: {
    nextPage () {
      return (this.totalPages - this.pageNumber) > 0
    },
    previousPage() {
      return (this.pageNumber > 1)
    },
    firstAndLast () {
      return (this.totalPages > 5)
    },
    disableSubmit() {
      return !this.applicantLast1 
    },
    showClearButton() {
      return (this.applicantLast1 || this.applicantLast2 || this.applicantFirst1 || this.applicantFirst2 || this.dateFirst || this.dateLast)
    }
  },
  methods: {
    async fetchResults() {
      this.loading = true;
      if (this.dateLast < this.dateFirst) {
        this.failure = true;
        this.loading = false;
       return
      }
      var preParams = {
        PageSize: this.pageSize,
        PageNumber: this.pageNumber,
      };
      if (this.applicantFirst1) {
        preParams["ApplicantFirst1"] = this.applicantFirst1;
      }
      if (this.applicantFirst2) {
        preParams["ApplicantFirst2"] = this.applicantFirst2;
      }
      if (this.applicantLast1) {
        preParams["ApplicantLast1"] = this.applicantLast1;
      }
      if (this.applicantLast2) {
        preParams["ApplicantLast2"] = this.applicantLast2;
      }
      if (this.dateFirst) {
        preParams["DateFrom"] = this.dateFirst;
      }
      if (this.dateLast) {
        preParams["DateTo"] = this.dateLast;
      }

      return axios
        .get(rowsSlug, {
          params: preParams,
        })
        .then(async (response) => {
          this.licenses = response.data.marriageRecords;
          this.totalPages = response.data.totalPages;
          this.pageNumber = response.data.pageNumber;
          this.totalCount = response.data.totalCount;
          if (!this.licenses.length) {
            this.failure = true;
            return;
          }
          this.failure = false;
          this.loading = false;
          this.showForm = false;
        })
        .catch(async () => {
          this.failure = true;
          return;
        });
    },

    clearInputs: function () {
      this.applicantFirst1 = "";
      this.applicantFirst2 = "";
      this.applicantLast1 = "";
      this.applicantLast2 = "";
      this.dateFirst = "";
      this.dateLast = "";
      this.licenses = [];
      this.failure = false;
    },

    incrementResults(pageNum) {
      this.loading = true;
      if (pageNum) {
        this.pageNumber = pageNum;
      } else {
      this.pageNumber = this.pageNumber + 1;
      }
      this.fetchResults();
    },

    decrementResults(pageNum) {
      this.loading = true;
      if (pageNum) {
        this.pageNumber = pageNum;
      } else {
      this.pageNumber = this.pageNumber - 1;
      }
      this.fetchResults();
    },

    revealForm: function () {
      this.showForm = true;
      this.failure = false;
      this.clearInputs();
    },
  },
  data: function () {
    return {
      licenses: [],
      pageNumber: 1,
      pageSize: "10",
      applicantFirst1: "",
      applicantFirst2: "",
      applicantLast1: "",
      applicantLast2: "",
      dateFirst: "",
      dateLast: "",
      failure: false,
      loading: false,
      showForm: true,
      totalPages : 0,
      totalCount: 0,
    };
  },
};
</script>
<style lang="scss" >
#rows-search {

  input {
  border-bottom: grey 1px solid;
  
  }
  input:focus {
    border-bottom: 2px solid #25cef7;
  }
  input[readonly] {
cursor: auto;
  }
}

.searchForm {
  padding: 0px 150px;
}

.results-table {
  padding: 0px 150px;
}
.half-width {
  width: 50%;
}
.cell input {
  margin: 0 10% 0 0;
}

.failure-message {
  background-color:#DAEDFE;
  padding: 20px 50px ;
  margin-top: 40px;
  p {
    padding: 0px;
  }
}

.callout-box {
  margin-top: 48px;
  border: solid 3px black;
  padding: 16px 0px;
  

  .icon-container {
    width: 42px;
    margin-left: 24px;
    margin-right: 24px;
  }

  .callout-text {
    margin: auto;
  }

  i {
    color: #0f4d90;
  }
}

.bg-white {
  background-color: white;
  text-align: center;
  margin: 4px;
  padding: 6px 0px;

}

.bg-blue {
  background-color: #0f4d90;
  color: white;
  text-align: center;
  margin: 4px;
  cursor: pointer;
  padding: 6px 0px;
}

  .vdp-datepicker__calendar .cell.selected,
  .vdp-datepicker__calendar .cell.selected.highlighted,
  .vdp-datepicker__calendar .cell.selected:hover {
    background: #25cef7;
    cursor: pointer;
  } 
.loading-icon {
  padding: 219.5px 0px;
  text-align: center;
}
.to-cell {
    margin-top: 7px;
    padding-left: 10px;
}

@media (max-width: 750px) {
  .small-12.all-results {
    width: 100%;
  }
  .results-table {
    padding: 0px ;
  }
  .searchForm {
    padding: 0px;
    .grid-x {
      flex-direction: column;
      .cell {
        width: 100%;
        padding-bottom: 0;
        padding-right:0;
      }
    }

    .grid-x.pbl {
      .cell {
        width: 50%;
        padding-bottom: 0;
      }
    }
  }

  .failure-message {
    padding: 15px 10px;
    p:first-of-type {
      margin-bottom: 5px;
    }
    h3 {
      margin-bottom: 0;
    }
  }

  .callout-box  {
    .small-2 {
      width: 16.6%;
    }
    .icon-container {
     margin: 0 7px;

    }
    .callout-text {
      margin: 0;
    }
  }

  .pag-buttons-wrap {
    .small-1 {
      min-width: 7%;
    }
    .small-2 {
      width: 17%;
    }
  }
}

.clear-btn{
  background: white;
  color: #0f4d90;
  text-decoration: underline;
}
</style>
